import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full py-20 px-6 pt-[30px] pb-[30px]" style={{
    background: 'var(--cream-dark)'
  }} aria-label="Garantía de satisfacción" data-id="element-154">
      <div className="max-w-3xl mx-auto" data-id="element-155">
        <div className="rounded-3xl p-10 md:p-14 text-center shadow-xl" style={{
        background: 'var(--cream)',
        border: '3px solid var(--gold-light)'
      }} data-id="element-156">
          {/* Shield icon */}
          <div className="w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg" style={{
          background: 'linear-gradient(135deg, var(--gold) 0%, var(--gold-dark) 100%)'
        }} data-id="element-157">
            <ShieldCheckIcon className="w-10 h-10 text-white" aria-hidden="true" data-id="element-158" />
          </div>

          {/* Badge */}
          <div className="inline-block px-6 py-2 rounded-full mb-6 text-sm font-bold tracking-widest uppercase" style={{
          background: 'var(--gold-light)',
          color: 'var(--brown)'
        }} data-id="element-159">
            🔒 Garantía de Satisfacción Total
          </div>

          <h2 className="text-4xl font-bold mb-6" style={{
          color: 'var(--brown)',
          fontFamily: 'Playfair Display, serif'
        }} data-id="element-160">
            30 Días Sin Preguntas
          </h2>

          <p className="text-lg leading-relaxed mb-6" style={{
          color: 'var(--brown-light)',
          lineHeight: '1.9'
        }} data-id="element-161">
            Sé lo que es gastar dinero en un libro de cocina que no funciona.
          </p>

          <p className="text-lg leading-relaxed mb-8" style={{
          color: 'var(--brown-light)',
          lineHeight: '1.9'
        }} data-id="element-162">
            Por eso esta garantía es simple: si en los próximos{' '}
            <strong style={{
            color: 'var(--brown)'
          }} data-id="element-163">
              30 días
            </strong>{' '}
            aplicas las técnicas del Método Repostería Zero, haces al menos 3
            recetas del libro y sientes que no valió la pena, te devuelvo el{' '}
            <strong style={{
            color: 'var(--brown)'
          }} data-id="element-164">
              100% de tu dinero
            </strong>{' '}
            sin preguntas, sin formularios complicados y sin demoras.
          </p>

          <div className="rounded-2xl p-6 mb-8" style={{
          background: 'var(--cream-dark)'
        }} data-id="element-165">
            <p className="text-2xl font-bold" style={{
            color: 'var(--gold-dark)',
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-166">
              Solo escríbeme. Punto.
            </p>
          </div>

          <p className="text-base italic" style={{
          color: 'var(--brown-light)',
          fontFamily: 'Cormorant Garamond, serif',
          fontSize: '1.1rem'
        }} data-id="element-167">
            Mi confianza en este sistema es total. Porque sé lo que puede hacer
            cuando se aplica correctamente.
          </p>
        </div>
      </div>
    </section>;
}